import { render, staticRenderFns } from "./DiscoveryPage.vue?vue&type=template&id=894edf68&scoped=true&"
import script from "./DiscoveryPage.vue?vue&type=script&lang=js&"
export * from "./DiscoveryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894edf68",
  null
  
)

export default component.exports